import { colorSelected } from "../actions";

const updateColor = (color, todoId) => {
  return async (dispatch) => {
    const response = await fetch(
      `https://lwsumit.herokuapp.com/todos/${todoId}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          color: color,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8 ",
        },
      }
    );
    const todo = await response.json();
    dispatch(colorSelected(color, todo.id));
  };
};

export default updateColor;
